<div class="table-container table-news">
  <div
    *ngIf=" newsItems && newsItems.length > 0"
    [@simpleFadeAnimation]="ready ? 'fadeIn': 'fadeOut'"
  >
    <div class="header">
      <h4>{{message}}</h4>
    </div>
    <table>
      <thead>
        <tr>
          <td>Date</td>
          <td>Title</td>
        </tr>
      </thead>
      <tbody *ngFor="let item of newsItems;let i = index">
        <tr [ngClass]="{'bg-even': 0 === i % 2}">
          <td class="date">
            {{dtService.agoPure(item.date)}}</td>
          <td
            class="title-cell"
            (click)="titleClicked(item)"
            [innerHtml]="item.title | safeHtml"
          >
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
